export var HashConnectConnectionState;
(function (HashConnectConnectionState) {
    HashConnectConnectionState["Connecting"] = "Connecting";
    HashConnectConnectionState["Connected"] = "Connected";
    HashConnectConnectionState["Disconnected"] = "Disconnected";
    HashConnectConnectionState["Paired"] = "Paired";
})(HashConnectConnectionState || (HashConnectConnectionState = {}));
//# sourceMappingURL=hashconnect.js.map